import { useEffect, useState } from "react";

export default function FollowCTA() {
  const [followed, setFollowed] = useState(false);
  const [readInit, setReadInit] = useState(false);

  useEffect(() => {
    const saved = window.localStorage.getItem("tcyx-follow");
    setFollowed(saved === "1");
    setReadInit(true);
  }, []);

  const toggle = () => {
    const next = !followed;
    setFollowed(next);
    window.localStorage.setItem("tcyx-follow", next ? "1" : "0");
  };

  return (
    <section id="follow" className="relative w-full py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="relative overflow-hidden rounded-lg">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20landscape%20with%20jade%20green%20mountains%20and%20cinnabar%20red%20seal%20stamp%20and%20floating%20herbs%2C%20elegant%20minimal%20composition%20with%20breathing%20space%20in%20center%2C%20dark%20tonal%20background&width=1400&height=500&seq=follow-cta-001&orientation=landscape"
              alt="天才医仙漫画收藏追更背景图"
              title="天才医仙漫画自动追更"
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-900/75 to-primary-900/55"></div>
          </div>

          <div className="relative flex flex-col items-start gap-6 px-6 py-10 md:px-12 md:py-14 lg:flex-row lg:items-center lg:justify-between">
            <div className="max-w-xl">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/15 px-3 py-1 text-xs text-background-50 backdrop-blur">
                <i className="ri-notification-3-line"></i>收藏自动追更
              </span>
              <h2 className="mt-3 font-heading text-2xl font-bold text-background-50 md:text-3xl">
                收藏本站，新章节第一时间提醒
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-background-100">
                今天有没有更新不用再到处找。点击下方按钮收藏《天才医仙》，最新章节与新话上线后都会第一时间提醒你回来追更。
              </p>
            </div>

            <div className="flex shrink-0 flex-col items-start gap-3 lg:items-end">
              <button
                type="button"
                onClick={toggle}
                className={`whitespace-nowrap rounded-md px-6 py-3 text-sm font-medium transition-colors ${
                  followed
                    ? "bg-background-50 text-primary-800"
                    : "bg-accent-500 text-background-50 hover:bg-accent-600"
                }`}
              >
                <i className={`${followed ? "ri-bookmark-fill" : "ri-bookmark-line"} mr-1.5`}></i>
                {followed ? "已收藏 · 追更中" : "收藏追更"}
              </button>
              <p className="text-xs text-background-100/80">
                {readInit ? (followed ? "已加入追更，更新时第一时间提醒" : "点击收藏后即可开启自动追更") : ""}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}